import $ from 'jquery';
jQuery.noConflict();

export function updateDealOfTheDayRootmenu() {
    const dt = new Date().getTime();
    const $links = $('.rootmenu a[href*="/dotd/"], .verticalmenu02 a[href*="/dotd/"]');

    if ($links.length) {
        $links.each(function () {
            const href = $(this).attr('href');
            if (href) {
                $(this).attr('href', href + '?cachebuster=' + dt);
            }
        });
    }
}

/* 
 * ZENDESK CHAT HELPERS
 */
function hideZendeskChat() {
    const launcher = document.getElementById('launcher');
    if (launcher) {
        launcher.parentElement.style.display = 'none';
    }
}
 
function showZendeskChat() {
    const launcher = document.getElementById('launcher');
    if (launcher) {
        launcher.parentElement.style.display = 'block';
    }
}

export function headerFunctions() {
    /* ===============================
     * TOGGLE SIDEBAR (ICON CLICK)
     * =============================== */
    $(document).on('click', 'span.cart.sidebar, span.top-login.account.sidebar', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $sidebar = $(this);
        const isAccount = $sidebar.hasClass('top-login');

        // Close other sidebar
        $('span.cart.sidebar, span.top-login.account.sidebar')
            .not($sidebar)
            .removeClass('selected')
            .find('.block-cart, .block-account')
            .hide()
            .removeClass('slide-in');

        // Toggle this sidebar
        $sidebar.toggleClass('selected');

        const $drawer = isAccount
            ? $sidebar.find('.block-account')
            : $sidebar.find('.block-cart');

        if ($sidebar.hasClass('selected')) {
            $drawer.show().addClass('slide-in');
            $('.wrapper-overlay-dark').show();

            document.body.classList.add('noscrollactive');
            document.documentElement.classList.add('noscroll');

            // Hide Zendesk chat when drawer opens
            hideZendeskChat();
        } else {
            $drawer.hide().removeClass('slide-in');
            $('.wrapper-overlay-dark').hide();
        }
    });

    /* ===============================
     * PREVENT INNER CLICKS
     * =============================== */
    $(document).on(
        'click',
        '.block-cart, .block-account',
        function (e) {
            if (!$(e.target).closest('.cart-drawer-close').length) {
                e.stopPropagation();
            }
        }
    );

    /* ===============================
     * CLOSE BUTTON (ONLY ONE)
     * =============================== */
    $(document).on(
        'click',
        '.cart-drawer-close, .cart-drawer-close *',
        function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            const $drawer = $(this).closest('.block-cart, .block-account');
            const $sidebar = $drawer.closest('span.cart.sidebar, span.top-login.account.sidebar');

            $drawer.hide().removeClass('slide-in');
            $sidebar.removeClass('selected');

            document.body.classList.remove('noscrollactive');
            document.documentElement.classList.remove('noscroll');

            if (!$('span.cart.sidebar.selected, span.top-login.account.sidebar.selected').length) {
                $('.wrapper-overlay-dark').hide();
            }

            // Show Zendesk chat when drawer closes
            showZendeskChat();
        }
    );

    /* ===============================
     * CLICK OUTSIDE CLOSE
     * =============================== */
    $(document).on('click', function () {
        if ($('span.cart.sidebar.selected, span.top-login.account.sidebar.selected').length) {
            $('span.cart.sidebar.selected, span.top-login.account.sidebar.selected')
                .removeClass('selected')
                .find('.block-cart, .block-account')
                .hide()
                .removeClass('slide-in');

            $('.wrapper-overlay-dark').hide();

            document.body.classList.remove('noscrollactive');
            document.documentElement.classList.remove('noscroll');

            // Show Zendesk chat when drawer closes
            showZendeskChat();
        }
    });

    /* ===============================
     * ESC KEY CLOSE
     * =============================== */
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('span.cart.sidebar.selected, span.top-login.account.sidebar.selected')
                .removeClass('selected')
                .find('.block-cart, .block-account')
                .hide()
                .removeClass('slide-in');

            $('.wrapper-overlay-dark').hide();

            document.body.classList.remove('noscrollactive');
            document.documentElement.classList.remove('noscroll');

            // Show Zendesk chat when drawer closes
            showZendeskChat();
        }
    });

    /* ===============================
     * OTHER UI (UNCHANGED)
     * =============================== */
    $('.pulldown').on('click', function (e) {
        e.stopPropagation();
    });

    $('.mini-search-icon').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.top-search').toggleClass('search-active');
    });

    $('.modal-mobile-signin .minimize-x').on('click', function () {
        $('.modal-mobile-signin').hide();
        $('.wrapper-overlay-dark').hide();
    });
}

document.addEventListener('click', function (e) {
    
    const openBtn = e.target.closest('.mobile-menu-trigger');
    const closeBtn = e.target.closest('.mobile-menu-close');

    if (openBtn) {
        document.body.classList.add('noscrollactive');
        document.documentElement.classList.add('noscroll');

        // Hide Zendesk chat when drawer opens
        hideZendeskChat();
    }

    if (closeBtn) {
        document.body.classList.remove('noscrollactive');
        document.documentElement.classList.remove('noscroll');

        // Show Zendesk chat when mobile nav closes
        showZendeskChat();
    }
});
